import Vue from 'vue'
import Vuetify from 'vuetify'

import router from './router/index'
import VueScrollTo from 'vue-scrollto'
import VueLazyLoad from 'vue-lazyload'

import store from './store'
import App from './App.vue'
import SvgIcon from 'vue-svgicon'

import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'
import colors from './scss/_colors.scss'

// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import plugins
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js'

// Import styles
import 'filepond/dist/filepond.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginImageValidateSize
)

Vue.config.productionTip = false
Vue.component(FilePond)
Vue.use(Vuetify)
Vue.use(VueLazyLoad)
Vue.use(SvgIcon, {
  tagName: 'svg-icon'
})

Vue.use(VueScrollTo)

/**
 * Defining a global prototype variable for blue buttons for now
 * A global data mixin can also be used here, will be looking for requirements
 */
Vue.prototype.$btnHwayzBlue = colors.hwayzBlue
Vue.prototype.$preloaderColor = colors.hwayzLightGreen

Vue.directive('custom-outside-click', {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
